module.exports = __webpack_public_path__ + "static/media/book.09305829.svg";